var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorSignIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.151,
    y: 0.933,
    width: 20.143,
    height: 20.143,
    rx: 10.072,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.394 5.767l-.214 7.166H9.27l-.214-7.166h2.338zM10.222 16.24a1.13 1.13 0 01-.855-.383 1.32 1.32 0 01-.353-.928c0-.356.118-.66.353-.913a1.13 1.13 0 01.855-.383c.32 0 .6.128.842.383.245.252.367.557.367.913 0 .242-.057.462-.172.66a1.325 1.325 0 01-.442.475c-.18.117-.378.176-.595.176z",
    fill: "#D13131"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSignIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/errorSignIcon.03a3433e.svg";
export { MemoForwardRef as ReactComponent };